import { brandImage, brandName, brandPoints, testimonials } from '@/mocks/homeData';

export default function BrandSection() {
  return (
    <section id="about" aria-labelledby="about-title" className="scroll-mt-28 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-72 w-full md:h-96">
                <img
                  src={brandImage}
                  alt={`${brandName} 现场氛围图`}
                  className="h-full w-full object-top"
                />
              </div>
            </div>
            <ul className="mt-6 grid grid-cols-3 gap-4 rounded-lg border border-background-200 bg-background-50 p-5 text-center">
              <li>
                <p className="font-heading text-xl font-bold text-primary-600">2021</p>
                <p className="mt-1 text-xs text-foreground-500">开始做热点梳理</p>
              </li>
              <li>
                <p className="font-heading text-xl font-bold text-primary-600">1200+</p>
                <p className="mt-1 text-xs text-foreground-500">累计整理事件</p>
              </li>
              <li>
                <p className="font-heading text-xl font-bold text-primary-600">98%</p>
                <p className="mt-1 text-xs text-foreground-500">更新及时率</p>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.25em] text-primary-600">ABOUT US</p>
            <h2
              id="about-title"
              className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl"
            >
              关于{brandName}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              {brandName}是一个专注网络红人热点事件的观察型内容站。我们不追着情绪跑,而是把散落在各个平台的信息收拢起来,按时间线还原事情的来龙去脉,并把「已经确认」和「仍在核实」清楚地分开标注。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              做这件事的初衷很简单:网络上的瓜太多,真假混着来,很多人只是想要一个相对冷静的梳理。我们愿意做那个慢一点、但更认真一点的整理者。
            </p>

            <ul className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {brandPoints.map((point) => (
                <li
                  key={point.title}
                  className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-800">
                    <i className={point.icon} aria-hidden="true" />
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-bold text-foreground-950">
                      {point.title}
                    </span>
                    <span className="mt-1 block text-xs leading-relaxed text-foreground-600">
                      {point.desc}
                    </span>
                  </span>
                </li>
              ))}
            </ul>

            <h3 className="mt-10 font-heading text-lg font-bold text-foreground-950">他们说</h3>
            <ul className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
              {testimonials.map((item) => (
                <li key={item.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-1 text-accent-500">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-sm" aria-hidden="true" />
                    ))}
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-700">{item.content}</p>
                  <div className="mt-4 border-t border-background-200 pt-3">
                    <p className="text-sm font-medium text-foreground-950">{item.name}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">{item.role}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}